import { UploadCloud, Camera, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The two ways in, side by side and the same size: send a clip (the lime one, the page's main action) or switch the camera on.
 * Keeps the ids the sticky bar, the tracking and the tests look for (hero-cta-btn, hero-practice-btn, data-cta).
 */
const base = "group relative flex flex-col justify-between text-left min-h-[80px] sm:min-h-[104px] rounded-[20px] p-3 sm:p-4 transition-[transform,box-shadow,border-color,background-color] duration-state ease-standard active:scale-[.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-300/80 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950";

export default function HeroDoors({ onAnalyse, onPractise, className }) {
  return (
    <div className={cn("grid grid-cols-[repeat(2,minmax(0,1fr))] gap-3 w-full max-w-[34rem] mx-auto lg:mx-0", className)} data-testid="hero-doors">
      <button type="button" onClick={onAnalyse} data-testid="hero-cta-btn" data-cta="hero_analyze"
        className={cn(base, "bg-gradient-to-b from-lime-300 to-lime-400 text-zinc-950 shadow-glow hover:shadow-[0_14px_44px_rgba(163,230,53,0.4)] hover:-translate-y-0.5")}>
        <span className="flex items-center justify-between">
          <UploadCloud className="w-6 h-6 lg:w-7 lg:h-7" strokeWidth={2} />
          <ArrowRight className="w-4 h-4 opacity-70 transition-transform group-hover:translate-x-0.5 lg:w-5 lg:h-5" aria-hidden="true" />
        </span>
        <span>
          <span className="block font-heading font-extrabold text-[17px] sm:text-lg leading-tight">Analyse a clip</span>
          <span className="block text-[12px] sm:text-[13px] leading-snug text-zinc-800">Upload a video, 2 free</span>
        </span>
      </button>
      <button type="button" onClick={onPractise} data-testid="hero-practice-btn" data-cta="hero_practice"
        className={cn(base, "glass border border-white/15 text-white hover:border-lime-400/60 hover:-translate-y-0.5")}>
        <span className="flex items-center justify-between">
          <Camera className="w-6 h-6 text-lime-300 lg:w-7 lg:h-7" strokeWidth={2} />
          <ArrowRight className="w-4 h-4 text-zinc-400 transition-transform group-hover:translate-x-0.5 lg:w-5 lg:h-5" aria-hidden="true" />
        </span>
        <span>
          <span className="block font-heading font-extrabold text-[17px] sm:text-lg leading-tight">Practise live</span>
          <span className="block text-[12px] sm:text-[13px] leading-snug text-zinc-400">Camera on, 10 min free</span>
        </span>
      </button>
    </div>
  );
}
